import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";


import ActivityFeed from "./ActivityFeed";
import SummaryPanel from "./Summarypanel";
import ActiveUsersChart from "./ActivityUser";
import ProgressChartCard from "../../Booklet/components/ProgressChartCard/ProgressChartCard";
import DonutWidget from "../../Components/GATEADMIN COMPONENETS/Donutchart";
import CommonChart from "../../Components/GATEADMIN COMPONENETS/CommanChart";
import { useDispatch } from "react-redux";
import { GateAdminDashboardData } from "../../Redux/Slices/GateAdminDashboard/Admindashboard";
import { useAppSelector } from "../../Redux/Store/Hooks";
import { object } from "zod";
import { ActiveUserFilter } from "../../Redux/Slices/GateAdminDashboard/ActiveUserFilter";
import { TestCompletedFilter } from "../../Redux/Slices/GateAdminDashboard/TestCompeletedFilter";
import { OverallActivityFilter } from "../../Redux/Slices/GateAdminDashboard/OverallActivityFilter";
import GrowthCard from "../../Components/GATEADMIN COMPONENETS/GrowthCard";

export const sampleData = {
  activityFeed: [
    {
      id: 1,
      title: "Test Completed",
      description: "Maya Singh | Math Test – Score: 92%",
      time: "2025-10-10 | 09:30",
    },
    {
      id: 2,
      title: "New User Registered",
      description: "Arjun Mehta | Manually Added (Free)",
      time: "2025-10-10 | 09:30",
    },
    {
      id: 3,
      title: "Payment Made",
      description: "Kavya Reddy | Paid Subscription – ₹799",
      time: "2025-10-10 | 09:30",
    },
    {
      id: 4,
      title: "New User Registered",
      description: "Arjun Mehta | Manually Added (Free)",
      time: "2025-10-10 | 09:30",
    },
    {
      id: 5,
      title: "Payment Made",
      description: "Kavya Reddy | Paid Subscription – ₹799",
      time: "2025-10-10 | 09:30",
    },
  ],
};

const GateAdminDashboard: React.FC = () => {
  const dispatch = useDispatch();
  const [Testfilter, setTestFilter] = useState("MONTHLY");

  const { data: Dashboard } = useAppSelector(
    (state) => state.GateAdminDashboardData
  );

  const { data: TestCompleted } = useAppSelector(
    (state) => state.TestCompletedFilter
  );
  const { data: OverallActivity } = useAppSelector(
    (state) => state.OverallActivityFilter
  );
  const { data: ActiveUser } = useAppSelector(
    (state) => state.ActiveUserFilter
  );

  const DashboardData: any = Dashboard?.data || {};
  const ActiveUserData: any = ActiveUser?.data || {};
  const TestCompletedData: any = TestCompleted?.data || {};
  const DOverallActivityData: any = OverallActivity?.data || {};

  console.log(DashboardData, "DashboardData");

  console.log(TestCompleted, "TestCompleted");
  console.log(OverallActivity, "OverallActivity");
  console.log(ActiveUserData, "ActiveUser");

  useEffect(() => {
    dispatch(GateAdminDashboardData());
    dispatch(ActiveUserFilter({ FilterBy: "MONTHLY" }));
    dispatch(TestCompletedFilter({ FilterBy: "MONTHLY" }));
    dispatch(OverallActivityFilter({ limit: 10 }));
  }, []);

  const handleTestFilter = (event: any) => {
    const newValue = event.target.value;
    setTestFilter(newValue);
    dispatch(TestCompletedFilter({ FilterBy: newValue }));
  };

  const stats = [
    {
      id: "total_students",
      title: "Total No. of Students",
      value: DashboardData?.total_no_of_students?.total_users ?? 0,
      change: DashboardData?.total_no_of_students?.difference_percentage ?? 0,
      lastMonthTotal:
        DashboardData?.total_no_of_students?.last_month_total ?? 0,
      times: DashboardData?.total_no_of_students?.times ?? 0,
    },
    {
      id: "new_users",
      title: "New Users ",
      value: DashboardData?.new_users?.this_month?.count ?? 0,
      change: DashboardData?.new_users?.difference_percentage ?? 0,
      lastMonthTotal: DashboardData?.new_users?.last_month_total ?? 0,
      times: DashboardData?.new_users?.times ?? 0,
    },
    {
      id: "online_users",
      title: "No. of Online Users",
      value: DashboardData?.no_of_online_users?.this_month?.total ?? 0,
      change: DashboardData?.no_of_online_users?.difference_percentage ?? 0,
      lastMonthTotal: DashboardData?.no_of_online_users?.last_month_total ?? 0,
      times: DashboardData?.no_of_online_users?.times ?? 0,
    },
    {
      id: "avg_session",
      title: "Avg. Session Length",
      value:
        DashboardData?.avg_session_length?.this_month?.avg_hhmmss ?? "00:00:00",
      change: DashboardData?.avg_session_length?.difference_percentage ?? 0,
      lastMonthTotal: DashboardData?.avg_session_length?.last_month_total ?? 0,
      times: DashboardData?.avg_session_length?.times ?? 0,
    },
  ];

  // ✅ Donut Chart Data
  const donutSections = Object.entries(
    DashboardData.total_questions_by_question_type || {}
  ).map(([title, data]: any) => ({
    title,
    total: data.total,
    active: data.active,
    inactive: data.inactive,
  }));

  // ✅ Summary Panel Data
  const rightStats = [
    { label: "Total Exams", value: DashboardData.total_exams ?? 0 },
    {
      label: "Total Exams Attempted",
      value: DashboardData.total_exams_attempted ?? 0,
    },
    { label: "Total Questions", value: DashboardData.total_questions ?? 0 },
    {
      label: "Active Questions",
      value: DashboardData.total_active_questions ?? 0,
    },
    {
      label: "Inactive Questions",
      value: DashboardData.total_inactive_questions ?? 0,
    },
    {
      label: "Total Practice Tests",
      value: DashboardData.total_practice_tests ?? 0,
    },
  ];

  // ✅ Registration Data
  const userRegistration = [
    {
      name: "Manual Subscribed Students",
      value: DashboardData.user_registration?.manual_students_subscribed ?? 0,
    },
    {
      name: "Stripe Subscribed Students",
      value: DashboardData.user_registration?.stripe_students_subscribed ?? 0,
    },
  ];

  // const registrationTotal = userRegistration.reduce(
  //   (sum, item) => sum + item.value,
  //   0
  // );

  const registrationTotal =
    DashboardData.user_registration?.total_students_subscribed ?? 0;

  // ✅ User Distribution (Login Statistics)
  const userDistribution = [
    {
      name: "Non-Subscribed Users",
      value: DashboardData.login_statistics?.non_subscribed_logged_users ?? 0,
    },
    {
      name: "Subscribed Users",
      value:
        DashboardData.login_statistics?.stripe_subscribed_logged_users ?? 0,
    },
    {
      name: "Manual Subscribed Users",
      value:
        DashboardData.login_statistics?.manual_subscribed_logged_users ?? 0,
    },
  ];

  // const distributionTotal = userDistribution.reduce(
  //   (sum, item) => sum + item.value,
  //   0
  // );
  const distributionTotal =
    DashboardData.login_statistics?.total_logged_users ?? 0;

  // ✅ Year Level Chart
  const levels =
    DashboardData.students_with_year_level?.map((item: any) => ({
      name: item.year_group,
      Student_Count: item.student_count,
    })) ?? [];

  // ✅ Packages Trend Chart
  const packages =
    DashboardData.package_usage_statistics?.map((pkg: any) => ({
      month: pkg.package_name,
      Student_Count: pkg.student_count,
    })) ?? [];

  const dataArray =
    ActiveUserData?.weekly_data ||
    ActiveUserData?.monthly_data ||
    ActiveUserData?.yearly_data ||
    [];

  const transformedActiveUsers = Array.isArray(dataArray)
    ? dataArray.map((item: any) => {
        let label = "";

        if (ActiveUserData?.weekly_data) {
          const date = new Date(item.date);
          label = date.toLocaleDateString("en-US", { weekday: "short" });
        } else if (ActiveUserData?.monthly_data) {
          const date = new Date(item.date);
          label = date.toLocaleDateString("en-US", { day: "2-digit" });
        } else if (ActiveUserData?.yearly_data) {
          label = item.month?.slice(0, 3) ?? "";
        }

        return {
          day: label,
          count: item.overall?.unique_students ?? 0,
        };
      })
    : [];

  const transformedTestCompleted = Array.isArray(
    TestCompletedData?.practice_tests
  )
    ? TestCompletedData.practice_tests.map((item: any) => {
        const rawName = item.test_name || "";
        const firstWord = rawName.split(" ")[0]; // 👈 take only first word

        return {
          name: firstWord,
          Total_test_attempts: item.total_attempts,
        };
      })
    : [];

  //   const transformedActivityFeed = Array.isArray(DOverallActivityData?.timeline)
  // ? DOverallActivityData.timeline.map((item: any, index: number) => {
  //     const type = item.type;
  //     const user = item.data?.user?.username ?? "Unknown User";
  //     const timestamp = new Date(item.timestamp);
  //     const formattedTime = `${timestamp.toISOString().split("T")[0]} | ${timestamp
  //       .toTimeString()
  //       .slice(0, 5)}`;

  //     let title = "";
  //     let description = "";

  //     switch (type) {
  //       case "practice_test_attempt": {
  //         const testName = item.data?.test?.name ?? "Unknown Test";
  //         const score = item.data?.attempt?.score;
  //         title = "Test Completed";
  //         description = `${user} | ${testName}${
  //           score !== null && score !== undefined ? ` – Score: ${score}%` : ""
  //         }`;
  //         break;
  //       }

  //       case "user_registration": {
  //         title = "New User Registered";
  //         const method = item.data?.registration_type
  //           ? ` | ${item.data.registration_type}`
  //           : " | Manually Added (Free)";
  //         description = `${user}${method}`;
  //         break;
  //       }

  //       case "stripe_subscription": {
  //         title = "Payment Made";
  //         const amount = item.data?.payment?.amount ?? 0;
  //         description = `${user} | Paid Subscription – ₹${amount}`;
  //         break;
  //       }

  //       default:
  //         title = "Activity";
  //         description = `${user} | ${type}`;
  //     }

  //     return {
  //       id: index + 1,
  //       title,
  //       description,
  //       time: formattedTime,
  //     };
  //   })
  // : [];

  return (
    <Box p={3}>
      {/* <Typography variant="h5" fontWeight={600} mb={2}>
        Dashboard
      </Typography> */}
      <Grid container spacing={2}>
        {stats.map((stat) => {
          // Choose color based on title
          let backgroundColor = "";
          let percentageColor = "";
          let color = "#000"; // default text color

          switch (stat.title) {
            case "Total No. of Students":
              backgroundColor = "#D8F3DC"; // light teal
              color = " #1C4E80";
              percentageColor = "#A1BBA5";
              break;
            case "New Users ":
              backgroundColor = "#B0E0E6"; // light blue
              color = "#202020";
              percentageColor = "#5B8B91"; // dark blue
              break;
            case "No. of Online Users":
              backgroundColor = "#FFE5D9"; // light red
              color = "#A64B3C";
              percentageColor = "#ff6a41be"; // dark red
              break;
            case "Avg. Session Length":
              backgroundColor = "#E6E6FA"; // light purple
              color = "#4B4B7C";
              percentageColor = "#9A9AF9"; /// dark purple
              break;
            default:
              backgroundColor = "#F3EAF9";
              color = "#BC57FF";
              percentageColor = "#ae3bfbff";
          }

          return (
            <Grid item xs={12} sm={6} md={3} key={stat.id}>
              <GrowthCard
                title={stat.title}
                value={stat.value}
                Percentage={stat.change}
                lastMonthTotal={stat.lastMonthTotal}
                times={stat.times}
                percentageColor={percentageColor}
                backgroundColor={backgroundColor}
                color={color}
              />
            </Grid>
          );
        })}
      </Grid>

      {/* Donut Widgets */}
      <Grid
        container
        spacing={2}
        mt={2}
        sx={{
          backgroundColor: "#fff",
          boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
          borderRadius: 2,
          marginLeft: "0px",
        }}
      >
        {donutSections.map((d) => {
          let color = "#4CB5F5"; // default blue

          switch (d.title) {
            case "Abstract Reasoning":
              color = "#4CB5F5"; // blue
              break;
            case "Reading Comprehension":
              color = "#A64B3C"; // red
              break;
            case "Writing":
              color = "#6AB187"; // green
              break;
            case "Quantitative Reasoning":
              color = "#B3C100"; // amber/yellow
              break;
            default:
              color = "#FFC107"; // purple (fallback)
          }

          return (
            <Grid item xs={12} sm={6} md={3} key={d.title}>
              <DonutWidget
                title={d.title}
                data={[
                  { name: "Active", value: d.active },
                  { name: "Inactive", value: d.inactive },
                ]}
                total={d.total}
                colors={color}
              />
            </Grid>
          );
        })}
      </Grid>

      <Grid
        container
        spacing={2}
        mt={1}
        sx={{
          height: { xs: "auto", md: 350 }, // auto height on mobile
        }}
      >
        <Grid item xs={12} md={8} sx={{ height: { xs: "auto", md: "100%" } }}>
          <Box sx={{ height: { xs: "auto", md: "100%" } }}>
            <ActivityFeed items={DOverallActivityData} />
          </Box>
        </Grid>

        <Grid item xs={12} md={4} sx={{ height: { xs: "auto", md: "100%" } }}>
          <Box sx={{ height: { xs: "auto", md: "100%" } }}>
            <SummaryPanel items={rightStats} />
          </Box>
        </Grid>
      </Grid>

      {/* Active Users Chart */}
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} md={12}>
          <ActiveUsersChart data={transformedActiveUsers} />
        </Grid>
      </Grid>

      {/* Common Charts */}
      <Grid container spacing={2} mt={1}>
        <Grid item xs={12} md={6}>
          <CommonChart
            title="Packages Trend"
            type="bar"
            data={packages}
            dataKey="Student_Count"
            nameKey="month"
            colors={["#FFD700", "#6C63FF", "#00BFA6", "#4C9AFF"]}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <CommonChart
            title="Student Level Distribution"
            type="bar"
            data={levels}
            dataKey="Student_Count"
            nameKey="name"
            colors={["#A0E7E5", "#64C7CC", "#4AA8B5", "#2E7C85"]}
          />
        </Grid>

        {/* User Registration & Distribution Charts */}
        <Grid container spacing={2} mt={1} sx={{ marginLeft: "0px" }}>
          <Grid item xs={12} md={6}>
            <ProgressChartCard
              title="User Registration"
              data={userRegistration}
              total={registrationTotal}
              colors={["#4C9AFF", "#6554C0"]}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <ProgressChartCard
              title="User Distribution"
              data={userDistribution}
              total={distributionTotal}
              colors={["#36B37E", "#FFAB00", "#6554C0"]}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={1}>
        <Grid item xs={12}>
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 2,
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)", // ✅ subtle shadow
              p: 2, // padding inside
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              margin={"0px 16px 16px 16px"}
            >
              <Typography variant="h6" sx={{ fontWeight: 600, fontSize: 16 }}>
                Test Completion Overview
              </Typography>

              <FormControl size="small" sx={{ minWidth: 140 }}>
                <Select
                  value={Testfilter}
                  sx={{
                    fontSize: 12,
                    height: 28,
                    backgroundColor: "#017CC9",
                    px: 1.5,
                    py: 0.4,
                    borderRadius: 1,
                    cursor: "pointer",
                    fontWeight: 500,
                    color: "#ffffff",
                    "& .MuiSelect-select": { py: 0.5 },
                    "& .MuiSvgIcon-root": {
                      color: "#fff",
                    },
                  }}
                  onChange={handleTestFilter}
                >
                  <MenuItem value="WEEKLY">Weekly</MenuItem>
                  <MenuItem value="MONTHLY">Monthly</MenuItem>
                  <MenuItem value="YEARLY">Yearly</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* ✅ Limit chart height */}
            <Box sx={{ height: 350 }}>
              <CommonChart
                title=""
                type="bar"
                data={transformedTestCompleted}
                dataKey="Total_test_attempts"
                nameKey="name"
                colors={["#36B37E", "#FFAB00", "#4C9AFF", "#1E6C73"]}
                noShadow
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GateAdminDashboard;
